import React, { useEffect } from "react";
import { RCCAlert, RCCButton,RCCGrid, RCCIcon, RCCTooltip } from "react-common-components";
import { useFieldArray } from "react-hook-form";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { v4 } from "uuid";
import LovStrategies from "src/components/Lov/Strategies";
import { IComponentStrategyTab } from "./interface";

const TabStrategies: React.FC<IComponentStrategyTab> = ({
	control,
	error,
	disabled = false,
	clearErrors,
	names,
	mapId,
	objectiveId,
	objectives
}) => {
	const { translate } = useTranslation();

	const { 
		fields: fieldsIndicators, 
		remove: removeIndicators,
		append: appendIndicators
	} = useFieldArray({
		control,
		name: names.nameOfObject
	});

	const addIndicator = () => {
		clearErrors(names.nameOfObject);
		const indicator: any = {};
		indicator.key = v4();
		indicator.id = v4();
		indicator.mee001Id = 0;
		appendIndicators(indicator);
	};

	const removeIndicator = (index: number) => {
		clearErrors(names.nameOfObject);			
		removeIndicators(index);
	};

	useEffect(() => {
		if(objectives)
			appendIndicators(objectives.map((indicator) => ({
				id: indicator.mee001Id,
				mee001Id: indicator.mee001Id,
				key: v4()
			})));
	}, []);

	return (
		<>
			<RCCGrid
				container
				item
				direction="column"
				alignItems="center"
				justifyContent="center"
			>
				<RCCGrid
					container
					item
				>
					<RCCGrid
						container
						item
						justifyContent="flex-end"
					>
						<RCCTooltip
							color="purple"
							text={translate("Vincular a uma estratégia")}
						>
							<RCCButton
								color="purple"
								icon={{
									name: "plus"
								}}
								layout="isRounded"
								size="md"
								onClick={addIndicator}
								disabled={disabled}
							/>
						</RCCTooltip>	
					</RCCGrid>
				</RCCGrid>
								
				<RCCGrid
					container
					item
				>
					{error[names.nameOfObject] && error[names.nameOfObject].message && (
						<Title color="red" size="xs">
							<RCCIcon
								name="infoCircle"
								color="var(--red)"
								style={{ marginRight: "8px"}}
							/>
							{error[names.nameOfObject].message}
						</Title>
					)}
					{fieldsIndicators.length === 0 && (
						<RCCAlert
							title={translate("Nenhuma estratégia vinculada")}
							description={translate("Aperte no botão acima para adicionar")}
						/>
					)}
					{fieldsIndicators.map((indicator: any, index) => (
						<RCCGrid
							container
							item
							direction="column"
							key={indicator.key ? indicator.key : `strategy-${indicator.key}`}
						>

							<RCCGrid
								container
								item
								alignItems="center"
								justifyContent="center"
							>
								<RCCGrid
									container
									item
									justifyContent="center"
									xs={11}
								>
									<LovStrategies 
										control={control}
										name={`${names.nameOfObject}[${index}].mee001Id`}
										label=""
										defaultValue={indicator.mee001Id ? String(indicator.mee001Id) : undefined}
										error={error[names.nameOfObject] && error?.[names.nameOfObject][index]?.mee001Id}
										disabled={disabled}
										onChangeCapture={() => clearErrors(names.nameOfObject)}
										extraParametersOnLoad={{
											mea001Id: mapId,
											mea003Id: objectiveId ?? ""
										}}
										extraParametersOnCreate={{
											mea001Id: mapId
										}}	
									/>
								</RCCGrid>
								<RCCGrid
									container
									item
									justifyContent="flex-end"
									xs={1}
								>
									<RCCTooltip
										color="red"
										text={translate("Excluir")}
									>
										<RCCButton
											color="transparent"
											icon={{
												name: "trash",
												color: "var(--red)"
											}}
											layout="isRounded"
											onClick={() => removeIndicator(index)}
											disabled={disabled}
											tabIndex={-1}
										/>
									</RCCTooltip>
								</RCCGrid>
							</RCCGrid>
						</RCCGrid>
					))}
				</RCCGrid>		
			</RCCGrid>
		</>
	);
};

export default TabStrategies;
